var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explore"},[_c('div',{staticClass:"content"},[(_vm.$route.params.type === '3d')?_c('scene-view-3-d',{attrs:{"options":{ type: '3d', x: this.$route.params.x, y: this.$route.params.y }}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }